import script from "./storeAmountLog.vue?vue&type=script&setup=true&lang=js"
export * from "./storeAmountLog.vue?vue&type=script&setup=true&lang=js"

import "./storeAmountLog.vue?vue&type=style&index=0&id=4bbdcd94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bbdcd94"]])

export default __exports__